export default __webpack_public_path__ + "static/media/patternVideo.b8a4b978.mp4";